
import { Typography,Box, Card, CardContent ,CardHeader} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import useStyles from "./salesStyle";
import { Bar, BarChart, ResponsiveContainer } from "recharts";
import { useTheme } from "@emotion/react";


function Sales() {
    const { t } = useTranslation();
    const theme = useTheme();

    const data = [
      {
        name: "Mon",
        uv: 4000,
      },
      {
        name: "Tue",
        uv: 3000,
      },
      {
        name: "Wed",
        uv: 2000,
      },
      {
        name: "Thu",
        uv: 2780,
      },
      {
        name: "Fri",
        uv: 1890,
      },
      {
        name: "Sat",
        uv: 2390,
      },
    ];
  
    return (
      <Card>
        <CardHeader title={t("salesHistory")} />
        <CardContent>
          <ResponsiveContainer width="99%" height={124}>
            <BarChart
              width={150}
              height={40}
              data={data}
              margin={{
                right: 0,
                left: 0,
              }}
            >
              <Bar
                dataKey="uv"
                fill={theme.palette.primary.main}
                radius={[50, 50, 50, 50]}
              />
            </BarChart>
          </ResponsiveContainer>
          <Box sx={{ display: "flex", alignItems: "center", mt: 3 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h2" component="div" marginBottom={1}>
                {200}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="div">
                {t("today")}
              </Typography>
            </Box>
            <TrendingUpIcon color="primary" />
          </Box>
        </CardContent>
      </Card>
    );
  };
  

export default Sales
